// Базовые URL для API.
// Все запросы (включая авторизацию) идут через b2b-микросервис — он сам
// проксирует /auth/login и /auth/me в user-микросервис Майнкрафтии.
// Так фронт знает только один origin и не страдает от CORS user-сервиса.

const isDev = typeof window !== 'undefined' && window.location.hostname === 'localhost';

// Базовый URL b2b-микросервиса.
// dev: проброс на VM 125 через NAT-порт 8682 на роутере.
// prod: через NPM на startklass.ru/api-b2b/*.
export const B2B_BASE = isDev
    ? 'http://85.175.7.40:8682'
    : 'https://startklass.ru/api-b2b';

// Для OAuth (Яндекс/Google) ходим напрямую в user-микросервис Майнкрафтии,
// минуя b2b. CORS-origin startklass.ru добавлен в user/app.py 2026-05-29.
export const USER_addres = 'https://minecraftia-school.ru/api-user';

// ===== Auth (прокси через b2b → user-микросервис) =====
export const API_login        = B2B_BASE + '/api/v1/b2b/auth/login';
export const API_me           = B2B_BASE + '/api/v1/b2b/auth/me';
export const API_B2B_register = B2B_BASE + '/api/v1/b2b/register';

// ===== B2B =====
export const API_B2B_centre_me      = B2B_BASE + '/api/v1/b2b/centre/me';
export const API_B2B_centre_status  = B2B_BASE + '/api/v1/b2b/centre/me/status';
export const API_B2B_articles       = B2B_BASE + '/api/v1/b2b/articles';

// Статьи и комментарии (проксируются из admin-микросервиса через b2b)
export const API_B2B_articles_list  = B2B_BASE + '/api/v1/b2b/articles';            // ?category=integration
export const API_B2B_article        = B2B_BASE + '/api/v1/b2b/articles/';           // + id
export const API_B2B_article_comment_post = B2B_BASE + '/api/v1/b2b/articles/';     // + id + '/comments'

// Базовый URL admin-микросервиса для картинок статей (featured_image и img в content)
export const ADMIN_ASSETS_URL = 'https://minecraftia-school.ru/api-admin';

// Динамические тарифы (зависит от месяца — март-июнь даёт скидку)
export const API_B2B_pricing        = B2B_BASE + '/api/v1/b2b/pricing';
// Заявки на счёт и обратный звонок
export const API_B2B_requests       = B2B_BASE + '/api/v1/b2b/requests';
export const API_B2B_my_requests    = B2B_BASE + '/api/v1/b2b/requests/mine';
export const API_B2B_my_invoices    = B2B_BASE + '/api/v1/b2b/centre/me/invoices';

// Платежи (Тинькофф) — пока не реализованы, оставлены задним числом
export const API_B2B_payment_init   = B2B_BASE + '/api/v1/b2b/payments/init';
export const API_B2B_payment_status = B2B_BASE + '/api/v1/b2b/payments/status/';
// Demo-состояние для b2b_lead
export const API_B2B_demo_state     = B2B_BASE + '/api/v1/b2b/demo-state/me';
